/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import whatsappLogo from 'my-phorest/assets/images/whatsapp.svg';
import smsLogo from 'my-phorest/assets/images/sms.svg';

export default class SelectChannelModal extends Component {
  whatsappLogoSrc = whatsappLogo;
  smsLogoSrc = smsLogo;
}
